import BaseService from '../base.service'
export class ArticleQrService extends BaseService {
  /**
   * The constructor for the ArtistService.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor (parameters = {}) {
    super('public/api/article', parameters)
  }
}